import React, { useState } from "react";
import { McTextarea } from "@maersk-global/mds-react-wrapper/components-core/mc-textarea";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { McRadioGroup } from "@maersk-global/mds-react-wrapper/components-core/mc-radio-group";
import { McRadio } from "@maersk-global/mds-react-wrapper/components-core/mc-radio";
import { Icon } from "@anchor/react-components/dist/lib/components";
import { uid } from "uid";
import UserInfo from "../../context/UserAccessContext";
import "./style.css";

function ReportComments({
  comments,
  setCommentsToSend,
  currentSectionHeading,
}) {

  const [comment, setComment] = useState("");
  const [currentCommentSectionToView, setCurrentCommentSectionToView] =
    useState("NEW");

  const [currentComment, setCurrentComment] = useState(
    comments ? comments[currentSectionHeading] : []
  );

  const { graphData } = UserInfo();

  const handleChangeComment = (event) => {

    setComment(event.target.value);
  };

  const addComment = () => {
    const currentDate = new Date();

    const day = currentDate.getDate().toString().padStart(2, "0");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Adding 1 because months are 0-indexed
    const year = currentDate.getFullYear().toString().slice(-2); // Extracting the last two digits of the year

    const formattedDate = `${day}/${month}/${year}`;

    const newComment = {
      commentId: uid(16),
      comment: comment,
      dateTime: formattedDate,

      CommentBy: graphData?.name,
      commentByGrp: "LT",
    };

    setCommentsToSend((currentComments) => ({
      ...currentComments,
      [currentSectionHeading]: {
        ...currentComments[currentSectionHeading],
        [currentCommentSectionToView]: [
          ...currentComments[currentSectionHeading][
            currentCommentSectionToView
          ],
          newComment,
        ],
      },
    }));
    setComment("");
  };


  const handleCommentsToView = (event) => {
    setCurrentCommentSectionToView(event.target.value);
  };


  const handleDeleteComment = (commentId) => {
    const updatedComments = comments[currentSectionHeading].NEW.filter(
      (comment) => comment.commentId !== commentId
    );
    setCommentsToSend((currentComments) => ({
      ...currentComments,
      [currentSectionHeading]: {
        ...currentComments[currentSectionHeading],
        [currentCommentSectionToView]: [...updatedComments],
      },
    }));
    // setCommentsToSend({ ...comments, NEW: updatedComments });
  };
  const handleEditComment = (commentId) => {
    const commentToEdit = comments[currentSectionHeading].NEW.find(
      (comment) => comment.commentId === commentId
    );
    setComment(commentToEdit.comment);
    handleDeleteComment(commentId);
  };

  return (
    <div
      className="comment_container"
      // style={{
      //   maxHeight: "500px",
      //   minHeight: "500px",
      //   width: "100%",
      //   overflowY: "scroll",
      //   borderRadius: "10px",
      //   padding: "20px",
      // }}
    >
      {currentCommentSectionToView !== "INREVIEW" &&
        currentCommentSectionToView !== "DONE" && (
          <div style={{ marginBottom: "5px" }}>
            <McTextarea
              name="explanation"
              label=""
              placeholder="Enter your comments here..."
              rows="5"
              value={comment}
              input={handleChangeComment} //If needed
              spellcheck="true"
              lang="en"
              disabled={
                currentCommentSectionToView === "INREVIEW" ||
                currentCommentSectionToView === "DONE"
              }
              hint="Add comments corresponding to the selected tab"
            ></McTextarea>
          </div>
        )}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <McRadioGroup
          name="comments"
          legend="Please select comments to view"
          orientation="horizontal"
        >
          <McRadio
            name="NEW"
            value="NEW"
            label="NEW"
            checked={currentCommentSectionToView === "NEW"}
            change={handleCommentsToView}
          ></McRadio>
          <McRadio
            name="INREVIEW"
            value="INREVIEW"
            label="INREVIEW"
            checked={currentCommentSectionToView === "INREVIEW"}
            change={handleCommentsToView}
          ></McRadio>
          <McRadio
            name="DONE"
            value="DONE"
            label="DONE"
            checked={currentCommentSectionToView === "DONE"}
            change={handleCommentsToView}
          ></McRadio>
        </McRadioGroup>
        {currentCommentSectionToView !== "INREVIEW" &&
          currentCommentSectionToView !== "DONE" && (
            <McButton
              label="+ Comment"
              appearance="primary"
              click={addComment}
              style={{ marginTop: "10px", marginLeft: "auto" }}
              disabled={!comment}
            ></McButton>
          )}
      </div>

      {comments &&
        comments[currentSectionHeading] &&
        comments[currentSectionHeading][currentCommentSectionToView] &&
        comments[currentSectionHeading][currentCommentSectionToView].map(
          (comment, index) => {
            return (
              <div
                key={index}
                className="comment"
                style={{
                  backgroundColor: "#E9F6FC",
                  borderRadius: "10px",
                  padding: "10px",
                  marginTop: "10px",
                  maxWidth: "max-content",
                  width: "100%",
                }}
              >
                {comment.CommentBy === graphData?.name && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Icon
                      className="editCommentIcon"
                      onClick={() => handleEditComment(comment.commentId)}
                      name="pencil"
                    />
                    <Icon
                      className="deleteCommentIcon"
                      onClick={() => handleDeleteComment(comment.commentId)}
                      name="times"
                    />
                  </div>
                )}
                <div>
                  <p style={{ margin: 0, wordBreak: "break-all" }}>
                    {comment.comment}
                  </p>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <p className="commenter">{comment.CommentBy}</p>
                    <p className="date">{comment.dateTime}</p>
                  </div>
                </div>
              </div>
            );
          }
        )}
    </div>
  );
}

export default ReportComments;
